<template>
  <div
    class="full"
    id="loginFull"
    @mousedown="down"
    @touchstart.stop="down"
    @mousemove="move"
    @touchmove.stop="move"
    @mouseup="end"
    @touchend.stop="end"
  >
    <div class="loginMember">
      <div class="head">
        <p>로그인</p>
      </div>

      <el-form
        class="loginForm"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="90px"
      >
        <el-form-item prop="id" label="아이디">
          <p class="labelId">아이디</p>
          <el-input v-model.number="ruleForm.id"></el-input>
        </el-form-item>

        <el-form-item prop="pass" label="비밀번호">
          <p class="labelPass">비밀번호</p>
          <el-input
            type="password"
            v-model="ruleForm.pass"
            autocomplete="off"
            @keyup.native.enter="submitForm('ruleForm')"
          ></el-input>
        </el-form-item>

        <div class="searchIdPass">
          <router-link
            :to="{ name: '기존회원번호확인' }"
            style="text-decoration: none; color: #008fd2"
          >
            <span class="existSearch">기존 회원 계정찾기</span>
          </router-link>

          <a class="dot">&#8901;</a>

          <router-link
            :to="{ name: '아이디찾기' }"
            style="text-decoration: none; color: #008fd2"
          >
            <span class="idSearch">아이디찾기</span>
          </router-link>

          <a class="dot">&#8901;</a>

          <router-link
            :to="{ name: '비밀번호찾기' }"
            style="text-decoration: none; color: #008fd2"
          >
            <span class="passwordSearch">비밀번호 찾기</span>
          </router-link>

          <a class="dot">&#8901;</a>

          <router-link
            :to="{ name: '회원선택' }"
            style="text-decoration: none; color: #008fd2"
          >
            <span class="createMember">회원가입</span>
          </router-link>
        </div>

        <el-form-item>
          <el-button id="submitButton" class="Button" @click="submitForm('ruleForm')"
            >로그인</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <MainFooter class="footer" />
    <!-- <mobile-footer class="footer" /> -->
  </div>
</template>

<script>
import build from "@/api/example";
import MainFooter from "./basic/mainFooter.vue";

export default {
  name: "loginMember",
  data() {
    return {
      startEvent: false,
      moveEvent: false,
      flags: false,
      dx: 50,
      dy: 50,
      position: {
        x: 320,
        y: 60,
      },
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      ruleForm: {
        isLogin: false,
        id: "",
        pass: "",
        userSe: "",
        isAdmin: false,
      },
      rules: {
        id: [{ required: true, message: "아이디를 입력하세요", trigger: "blur" }],
        pass: [{ required: true, message: "비밀번호를 입력하세요", trigger: "blur" }],
      },
      mobileTouch: true,
      checkMobile: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkLoginIdRequest();
        } else {
          return false;
        }
      });
    },

    // 로그인 전 아이디 확인
    async checkLoginIdRequest() {
      if (this.ruleForm.id !== "" && this.ruleForm.id) {
        build
          .get("/api/member/passLogin", {
            params: { userId: this.ruleForm.id.trim() },
          })
          .then((res) => {
            console.log(res);
            // 성공 시 로그인 시도
            this.doLogin();
          })
          .catch((err) => {
            console.log(err);
            if (err.response) {
              if (!this.checkMobile) {
                this.$fire({
                  text: err.response.data,
                  type: "error",
                });
              } else {
                alert(err.response.data);
              }
            }
          });
      } else {
        if (!this.checkMobile) {
          this.$fire({
            text: "아이디를 입력해주세요.",
            type: "error",
          });
        } else if (this.checkMobile) {
          alert("아이디를 입력해주세요.");
        }
      }
    },
    // 로그인
    async doLogin() {
      try {
        console.log("########## doLogin ##########");
        const response = await build.post("/mer/api/member/login", {
          userId: this.ruleForm.id.trim(),
          password: this.ruleForm.pass.trim(),
        });

        this.$store.state.loginMemberIndex = response.data.id;

        if (this.ruleForm.id !== "") {
          //로그인 성공
          console.log("########## 로그인 성공 ##########");

          this.$store.state.isLogin = true;
          if (response.data.userSe === "ADMIN") {
            this.$store.state.isAdmin = true;
          }

          if (response.data.userSe === "BSN") {
            this.$store.state.isBusiness = true;
          }

          this.submitLoginDateInfo();

          this.$router.push({ name: "홈" });
          this.$store.state.popupCheck = true;
        } else {
          if (!this.checkMobile) {
            this.$fire({
              text: "아이디를 입력해주세요.",
              type: "error",
            });
          } else if (this.checkMobile) {
            alert("아이디를 입력해주세요.");
          }
        }
      } catch (error) {
        if (!this.checkMobile) {
          this.$fire({
            text: "비밀번호를 확인해주세요",
            type: "error",
          });
        } else if (this.checkMobile) {
          alert("비밀번호를 확인해주세요");
        }
      }
    },
    submitLoginDateInfo() {
      build
        .post("/api/member/updateLoginDate")
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    down(event) {
      this.flags = true;

      var touch;

      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }

      this.dx = touch.clientX - event.target.offsetLeft;
      this.dy = touch.clientY - event.target.offsetTop;
    },
    move(event) {
      if (this.flags) {
        var touch;

        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }

        this.position.x = touch.clientX - this.dx;
        this.position.y = touch.clientY - this.dy;

        // if (this.position.x < 0) {
        //     this.position.x = 0
        // }
        // else
        if (this.position.x > this.screenWidth - touch.target.clientWidth) {
          this.position.x = this.screenWidth - touch.target.clientWidth;
        }

        if (this.position.y < 0) {
          this.position.y = 0;
        } else if (this.position.y > this.screenHeight - touch.target.clientHeight) {
          this.position.y = this.screenHeight - touch.target.clientHeight;
        }

        document.addEventListener(
          "touchmove",
          (ev) => {
            ev.preventDefault();
          },
          false
        );
      }
    },
    end() {
      this.flags = false;
    },
    isMobile() {
      var user = navigator.userAgent;

      // console.log(user)

      if (
        user.indexOf("iPhone") > -1 ||
        user.indexOf("Android") > -1 ||
        user.indexOf("iPad") > -1 ||
        user.indexOf("iPod") > -1
      ) {
        this.checkMobile = true;
      }
    },
  },
  components: {
    MainFooter,
  },
  mounted() {
    window.scrollTo(0, 0);

    if (this.$store.state.isLogin == true) {
      this.$router.push({ name: "홈" });
    }

    this.isMobile();

    window.addEventListener("touchmove", () => {
      this.mobileTouch = false;
    });

    window.addEventListener("touchstart", () => {
      this.mobileTouch = true;
    });

    window.addEventListener("touchcancel", () => {
      this.mobileTouch = true;
    });

    window.addEventListener("touchend", () => {
      this.mobileTouch = true;
    });
  },
  unmounted() {
    window.removeEventListener("touchmove", () => {});
    window.removeEventListener("touchstart", () => {});
    window.removeEventListener("touchcancel", () => {});
    window.removeEventListener("touchend", () => {});
  },
};
</script>

<style scoped>
@import "@/assets/css/reset.css";

/* 전체 위치 정렬 */
.star {
  display: none;
}

.labelId {
  display: none;
}

.labelPass {
  display: none;
}
.loginMember {
  margin: 0;
  padding: 0;
  /* margin-left: 3%; */
  margin-top: 6vh;
  /* width: 1200px; */
  height: 58vh;
  text-align: center;
  overflow: hidden !important;
}

.loginForm {
  margin-right: auto;
}

.el-form {
  /* margin: 0;
        padding: 0; */
  width: auto;
  height: auto;
  text-align: center;
  font: normal normal 700 40px/58px Noto Sans KR;
  color: #5a5b5e;
  display: inline-block;
  padding-top: 10px;

  /* background-color: #4ca5a5; */
}
.is-error >>> .el-form-item__error {
  float: left;
  padding-left: 5px;
}

#loginFull {
  margin: 0 !important;
}

/* 전체 input 넓이 조정 */
.el-input {
  width: 100%;
  float: center;
  color: #5a5b5e;
  /* margin-bottom: 10px; */
}

.el-form-item {
  text-align: center;
  /* background-color: #464646; */
}

.el-form >>> .el-form-item__label {
  text-align: left;
  display: inline-block;
}

.el-form >>> .el-form-item__label::before {
  display: none;
}

.searchIdPass {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font: normal normal normal 12px/21px Noto Sans KR;
  color: #008fd2;
  margin-bottom: 5%;
  /* margin-left: 15.5%; */
}

.dot {
  margin-left: 1%;
  margin-right: 1%;
}

/* 머리 제목글과 내용 */
.head {
  width: 100%;
  text-align: center;
  font: normal normal 40px/58px Noto Sans KR-BOLD;
  letter-spacing: -1px;
  color: #5a5b5e;
  margin-bottom: 2%;
  margin-left: 45px;
  /* background-color: plum; */
}

.Button {
  padding: 0;
  width: 110px;
  height: 45px;
  text-align: center;
  /* margin-right: 1%; */
  background: #008fd2 0% 0% no-repeat padding-box;
  font: normal normal 300 16px/24px Noto Sans KR;
  letter-spacing: 0px;
  color: #ffffff;
  border-radius: 0;
}

.footer {
  position: relative;
  bottom: 0;
  width: auto;
  margin-top: 10px;
  /* padding-left: 22%; */
  display: inline-block;
  overflow: hidden;
}

/* 반응형 css */

/* 1024px 태블릿 모드 */
@media all and (max-width: 1024px) {
  .is-error >>> .el-form-item__error {
    float: left;
    padding-left: 25vw;
  }
  .el-form >>> .el-form-item__label {
    display: none;
  }

  .el-form >>> .el-form-item__content {
    margin: 0 !important;
  }

  .labelId {
    display: block;
    font: normal normal 700 14px/40px Noto Sans KR;
    color: #5a5b5e;
    margin-bottom: 1%;
    text-align: left;
    margin-left: 26%;
  }

  .labelPass {
    display: block;
    font: normal normal 700 14px/40px Noto Sans KR;
    color: #5a5b5e;
    margin-bottom: 1%;
    text-align: left;
    margin-left: 26%;
  }

  .loginMember {
    width: 100vw;
    margin-top: 0vh;
    height: 76vh;
  }

  .head {
    margin-left: 0;
  }

  .loginMember {
    width: 100vw;
  }

  .el-form {
    width: 100vw;
  }

  .el-input {
    width: 50%;
    float: center;
    color: #5a5b5e;
    /* margin-bottom: 10px; */
  }

  .searchIdPass {
    justify-content: center;
  }

  .footer {
    width: 100vw;
  }
}

@media all and (max-width: 768px) {
  .el-form >>> .el-form-item__label {
    display: none;
  }

  .el-form >>> .el-form-item__content {
    margin: 0 !important;
  }

  .labelId {
    display: block;
    font: normal normal 700 14px/40px Noto Sans KR;
    color: #5a5b5e;
    margin-bottom: 1%;
    text-align: left;
    margin-left: 20%;
  }

  .labelPass {
    display: block;
    font: normal normal 700 14px/40px Noto Sans KR;
    color: #5a5b5e;
    margin-bottom: 1%;
    text-align: left;
    margin-left: 20%;
  }

  .loginMember {
    width: 100vw;
    margin-top: 5vh;
  }

  .head {
    margin-left: 0;
    margin: 0;
    font: normal normal 30px/58px Noto Sans KR-BOLD;
  }

  .el-input {
    width: 60%;
    float: center;
    color: #5a5b5e;
    /* margin-bottom: 10px; */
  }

  .el-form {
    width: 100vw;
  }

  .footer {
    width: 100vw;
  }
}

@media all and (max-width: 468px) {
  .el-form >>> .el-form-item__label {
    display: none;
  }

  .el-form >>> .el-form-item__content {
    margin: 0 !important;
  }

  .loginMember {
    width: 100vw;
    overflow: hidden !important;
  }

  .el-input {
    margin: 0 !important;
    width: 80%;
    float: center;
    color: #5a5b5e;

    /* margin-bottom: 10px; */
  }

  .labelId {
    display: block;
    font: normal normal 700 14px/40px Noto Sans KR;
    color: #5a5b5e;
    margin-bottom: 1%;
    text-align: left;
    margin-left: 11%;
  }

  .labelPass {
    display: block;
    font: normal normal 700 14px/40px Noto Sans KR;
    color: #5a5b5e;
    margin-bottom: 1%;
    text-align: left;
    margin-left: 11%;
  }

  .head {
    margin: 0;
  }

  .el-form {
    width: 100vw;
    margin-right: 12%;
  }

  .searchIdPass {
    /* flex-direction: column; */
    margin-left: 0%;
    font: normal normal normal 14px/21px Noto Sans KR;
  }

  .footer {
    width: 100vw;
  }

  .Button {
    width: 100px;
    height: 40px;
    font: normal normal 300 15px/24px Noto Sans KR;
  }

  .is-error >>> .el-form-item__error {
    float: left;
    padding-left: 35%;
  }

  /* .el-form >>> .el-form-item__label {
            width: 22% !important;
            padding: 0 !important;
        } */
}

@media all and (max-width: 341px) {
  .searchIdPass {
    /* flex-direction: column; */
    font: normal normal normal 13px/21px Noto Sans KR;
  }
}
</style>
